import {QRCodeSVG} from 'qrcode.react';
import {useTranslation} from 'react-i18next';

import {getHttpUrl} from './receiptQr';

interface ReceiptQrPreviewProps {
  url?: string | null;
  legacyImage?: string | null;
  className?: string;
}

const ReceiptQrPreview = ({url, legacyImage, className = 'mb-0'}: ReceiptQrPreviewProps) => {
  const {t} = useTranslation();
  const qrUrl = getHttpUrl(url);
  if (!qrUrl && !legacyImage) return null;

  return (
    <figure className={`${className}${qrUrl ? ' w-auto' : ''}`}>
      {qrUrl ? (
        <QRCodeSVG value={qrUrl} size={160} title={t('qr_code_preview')} />
      ) : (
        <img alt={t('qr_code_preview')} src={legacyImage ?? undefined} />
      )}
    </figure>
  );
};

export default ReceiptQrPreview;
